function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";
import Layout from '../../components/Layout';
import Image from 'next/image';
import LinkLarge from '../../components/linkLarge/LinkLarge';
import styles from './index.module.scss';
import meta from '../../content/meta';
var Contact = function(param) {
    var preamble = param.preamble, content = param.content, links = param.links;
    return /*#__PURE__*/ _jsxs(Layout, {
        title: 'Contact & About',
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.links,
                children: links.map(function(link) {
                    return /*#__PURE__*/ _jsx(LinkLarge, _objectSpread({}, link), link.href);
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                dangerouslySetInnerHTML: {
                    __html: preamble
                }
            }),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.image,
                        children: /*#__PURE__*/ _jsx(Image, {
                            src: '/images/photo.jpg',
                            alt: meta.artistName,
                            title: meta.artistName,
                            width: 700,
                            height: 467,
                            layout: 'responsive'
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        dangerouslySetInnerHTML: {
                            __html: content
                        }
                    })
                ]
            })
        ]
    });
};
export var __N_SSG = true;
export default _withSuperJSONPage(Contact);
